import React from 'react'
import PropTypes from 'prop-types'

import {
  createUrlIdc,
  cleanString,
  getCookieLocationLeft,
  getCookieLocationRight,
} from 'utils/utils'
import { ORIGIN_PAGES } from 'utils/constants'

import Link from '../../../../../../components/Link'

import * as S from './styles'

const CategoryCard = ({ category, origin }) => {
  const { title, background, slug, url, target } = category

  const slugOptions = {
    toLowerCase: 1,
    removeAccents: 1,
    removeSpecial: 1,
    slugify: 1,
  }

  const locationLeft = getCookieLocationLeft()
  const locationRight = getCookieLocationRight()

  const isPCD = title === 'Carros para PCD'
  const name = cleanString(title, slugOptions)
  const parsedUrl = cleanString(slug, slugOptions)
  const statusUrl = isPCD ? 'carros-novos' : 'carros'

  const urlParts = [parsedUrl, statusUrl, locationLeft].join('/')
  const queryStrings = {
    estadocidade: locationRight || '',
    necessidade: encodeURIComponent(title),
    tipoveiculo: isPCD && 'carros-novos',
  }

  const queryStringUrl = Object.entries(queryStrings)
    .reduce((acc, [key, value]) => {
      const hasKeyAndValue = key && value

      if (hasKeyAndValue) {
        return `${acc}${key}=${value}&`
      }

      return acc
    }, '')
    .replace(/&$/, '')

  const getOrigin = () => ORIGIN_PAGES[origin]

  const baseUrl = `/${urlParts}?${queryStringUrl}`

  const urlFinal = createUrlIdc(
    baseUrl,
    getOrigin(),
    `busque-por-categorias`,
    `${name}:comprar`,
    ''
  )

  const link = url || urlFinal

  return (
    <S.Container background={background}>
      <Link to={link} target={target}>
        <S.Title>{title}</S.Title>
      </Link>
    </S.Container>
  )
}

CategoryCard.defaultProps = {
  origin: ORIGIN_PAGES.HOME.KEY,
}

CategoryCard.propTypes = {
  category: PropTypes.shape({
    background: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    url: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
  }).isRequired,
  origin: PropTypes.string,
}

export default CategoryCard
